import { Tooltip } from '@shopify/polaris';
import { memo } from 'react';
import { SwitchStyled } from './styled';

interface Props {
  isActive: boolean;
  onSwitch: (checked: boolean) => void;
  isLoading?: boolean;
  disabled?: boolean;
  customTooltipWhenDisabled?: string;
}

const Switch = ({ isLoading, customTooltipWhenDisabled, ...props }: Props) => {
  return (
    <SwitchStyled>
      <Tooltip
        content={
          props.disabled && customTooltipWhenDisabled ? customTooltipWhenDisabled : props.isActive ? 'Turn on' : 'Turn off'
        }
      >
        {
          <div
            className={`rule-toggle ${props.isActive && 'active'} ${isLoading ? 'disable' : ''}`}
            onClick={() => props.onSwitch(!props.isActive)}
            // onClick={() => (props.disabled ? () => {} : props.onSwitch(!props.isActive))}
            style={{ backgroundColor: props.disabled ? '#dddddd' : undefined, cursor: props.disabled ? 'default' : 'pointer' }}
          />
        }
      </Tooltip>
    </SwitchStyled>
  );
};

export default memo(Switch);
